/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dark[_ngcontent-%COMP%]{background-color:#2e2e2e!important}.light[_ngcontent-%COMP%]{color:#fafafa!important;font-family:'Franklin Gothic Medium','Arial Narrow',Arial,sans-serif!important}.fullscreen[_ngcontent-%COMP%]{position:fixed;top:0;left:0;bottom:0;right:0;overflow:auto}.padd[_ngcontent-%COMP%]{margin-top:65px;padding:10px}\n/*# sourceMappingURL=importador.component.css.map*/"];
export { styles as styles };
